import { getConfig } from "../getConfig";

export const getProperties = () => {
    const teamPreventConfig = getConfig();
    return {
        environment: teamPreventConfig.EnvironmentName,
        application: teamPreventConfig.ApplicationName
    };
};
